import React from 'react';
import { useSelector } from 'react-redux';
import { selectedMetricSelector } from '@src/store/metricsChartContainer/selectors';
import { FLOW_ERROR_ANALYSIS_STATIC_DIMENSIONS } from '@utils/dimension/appDimensionHelper';
import { QueryViewId } from '@utils/constants';
import { useCurrentFlowConfig } from '@src/hooks/flow/useFlowConfigs';
import StaticTableWidget from './StaticTable';
import { useFlowScopeMetrics } from '../../hooks/useFlow';

function FlowErrorAnalysisWidget() {
  const selectedMetric = useSelector(selectedMetricSelector);
  const flowMeta = useCurrentFlowConfig();
  const flowMetrics = useFlowScopeMetrics('error', flowMeta);
  const flowErrorMetric = flowMeta?.metaDefinition.metrics
    .filter((it) => it.scope === 'error')
    .map((it) => it.identifier);

  if (!flowErrorMetric?.includes(selectedMetric)) return null;

  return (
    <>
      {FLOW_ERROR_ANALYSIS_STATIC_DIMENSIONS.map((item) => {
        return (
          <StaticTableWidget
            key={item.dimension}
            header={item.header}
            dimension={item.dimension}
            viewId={QueryViewId.ERROR_ANALYSIS}
            {...flowMetrics}
          />
        );
      })}
    </>
  );
}

export default FlowErrorAnalysisWidget;
